import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { cardList, price_detail } from '@/services/http';
import { readCookie, writeCookie, removeCookie } from '@/tools/tools';
import { whiteState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<CardState, RootState> = {
//   addresslist: (state: CardState) => state.cardnumber,
// };

/**
 * mutations
 */
export const mutations: MutationTree<whiteState> = {
  // 购物车变化
  CARDNUMBER(state: whiteState, payload: number) {
    state.whiteStauts = payload;
  }
};

/**
 * actions
 */
export const actions: ActionTree<whiteState, RootState> = {
  async setWhiteStauts({ commit }) {
    // 获取白拿状态
    const anchor = readCookie('anchor');
    const reslist: any = await price_detail({
      companyId: 1,
      // cartIds: selectedIds,
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      languageType: anchor ? Number(anchor.languageType) + 1 : ''
    });
    commit('CARDNUMBER', reslist.data.data);
  }
};
/**
 * state
 */
export const state: whiteState = {
  whiteStauts: {}
};
const namespaced: boolean = true;

export const white: Module<whiteState, RootState> = {
  namespaced,
  state,
  // getters,
  mutations,
  actions
};
